import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Title,
  SimpleGrid,
  Card,
  Text,
  Stack,
  Group,
  Loader,
  Alert,
  Button,
  Chip,
  Box,
  Pagination,
  TextInput,
  Select
} from '@mantine/core';
import {
  IconExclamationCircle,
  IconFilter,
  IconPhoto,
  IconSearch,
  IconVideo
} from '@tabler/icons-react';
import { useApi } from '../api';
import { useState, useEffect } from 'react';
import SellerCard from '../components/sellers/SellerCard';

const allAttributes = [
  // Size
  { value: 'small-feet', label: 'Small Feet' },
  { value: 'large-feet', label: 'Large Feet' },
  { value: 'medium-feet', label: 'Medium Feet' },
  { value: 'petite-feet', label: 'Petite Feet' },
  { value: 'big-feet', label: 'Big Feet' },

  // Shape
  { value: 'fat-feet', label: 'Fat Feet' },
  { value: 'thin-feet', label: 'Thin Feet' },
  { value: 'wide-feet', label: 'Wide Feet' },
  { value: 'narrow-feet', label: 'Narrow Feet' },
  { value: 'curvy-feet', label: 'Curvy Feet' },

  // Skin Tone
  { value: 'tan-feet', label: 'Tan Feet' },
  { value: 'fair-feet', label: 'Fair Feet' },
  { value: 'dark-feet', label: 'Dark Feet' },
  { value: 'olive-feet', label: 'Olive Feet' },
  { value: 'brown-feet', label: 'Brown Feet' },
  { value: 'pale-feet', label: 'Pale Feet' },

  // Toe Shape
  { value: 'long-toes', label: 'Long Toes' },
  { value: 'short-toes', label: 'Short Toes' },
  { value: 'round-toes', label: 'Round Toes' },
  { value: 'square-toes', label: 'Square Toes' },
  { value: 'pointed-toes', label: 'Pointed Toes' },
  { value: 'oval-toes', label: 'Oval Toes' },

  // Toe Conditions
  { value: 'missing-toe', label: 'Missing Toe' },
  { value: 'extra-toe', label: 'Extra Toe' },
  { value: 'webbed-toes', label: 'Webbed Toes' },
  { value: 'curled-toes', label: 'Curled Toes' },
  { value: 'bunions', label: 'Bunions' },

  // Nails - Polish Colors
  { value: 'red-nail-polish', label: 'Red Nail Polish' },
  { value: 'pink-nail-polish', label: 'Pink Nail Polish' },
  { value: 'purple-nail-polish', label: 'Purple Nail Polish' },
  { value: 'blue-nail-polish', label: 'Blue Nail Polish' },
  { value: 'black-nail-polish', label: 'Black Nail Polish' },
  { value: 'white-nail-polish', label: 'White Nail Polish' },
  { value: 'gold-nail-polish', label: 'Gold Nail Polish' },
  { value: 'silver-nail-polish', label: 'Silver Nail Polish' },
  { value: 'nude-nail-polish', label: 'Nude Nail Polish' },
  { value: 'neon-nail-polish', label: 'Neon Nail Polish' },
  { value: 'glitter-nail-polish', label: 'Glitter Nail Polish' },
  { value: 'matte-nail-polish', label: 'Matte Nail Polish' },

  // Nail Art & Designs
  { value: 'french-manicure', label: 'French Manicure' },
  { value: 'gel-nails', label: 'Gel Nails' },
  { value: 'acrylic-nails', label: 'Acrylic Nails' },
  { value: 'nail-art', label: 'Nail Art' },
  { value: 'rhinestones', label: 'Rhinestones' },
  { value: 'charms', label: 'Charms' },
  { value: 'studs', label: 'Studs' },
  { value: 'gradient-ombres', label: 'Gradient/Ombré' },
  { value: 'marble-nails', label: 'Marble Nails' },
  { value: 'chrome-nails', label: 'Chrome Nails' },
  { value: 'floral-nails', label: 'Floral Nails' },
  { value: 'animal-print', label: 'Animal Print' },

  // Pedicure Types
  { value: 'spa-pedicure', label: 'Spa Pedicure' },
  { value: 'classic-pedicure', label: 'Classic Pedicure' },
  { value: 'gel-pedicure', label: 'Gel Pedicure' },
  { value: 'acupuncture-pedicure', label: 'Acupuncture Pedicure' },
  { value: 'hot-stone-pedicure', label: 'Hot Stone Pedicure' },
  { value: 'fish-pedicure', label: 'Fish Pedicure' },
  { value: 'paraffin-pedicure', label: 'Paraffin Pedicure' },

  // Foot Features
  { value: 'tattoos', label: 'Tattoos' },
  { value: 'piercings', label: 'Piercings' },
  { value: 'foot-jewelry', label: 'Foot Jewelry' },
  { value: 'ankle-bracelets', label: 'Ankle Bracelets' },
  { value: 'toe-rings', label: 'Toe Rings' },
  { value: 'pedicure-extras', label: 'Pedicure Extras' },

  // Sole Characteristics
  { value: 'soft-soles', label: 'Soft Soles' },
  { value: 'rough-soles', label: 'Rough Soles' },
  { value: 'calloused-soles', label: 'Calloused Soles' },
  { value: 'smooth-soles', label: 'Smooth Soles' },
  { value: 'ticklish-feet', label: 'Ticklish Feet' },
  { value: 'arched-feet', label: 'Arched Feet' },
  { value: 'flat-feet', label: 'Flat Feet' },
  { value: 'high-arches', label: 'High Arches' },

  // Foot Condition
  { value: 'moisturized-feet', label: 'Moisturized Feet' },
  { value: 'dry-feet', label: 'Dry Feet' },
  { value: 'perfumed-feet', label: 'Perfumed Feet' },
  { value: 'fresh-feet', label: 'Fresh Feet' },
  { value: 'dirty-feet', label: 'Dirty Feet' },
  { value: 'sweaty-feet', label: 'Sweaty Feet' },
  { value: 'warm-feet', label: 'Warm Feet' },
  { value: 'cool-feet', label: 'Cool Feet' },

  // Accessories
  { value: 'barefoot', label: 'Barefoot' },
  { value: 'socks', label: 'Socks' },
  { value: 'stockings', label: 'Stockings' },
  { value: 'flip-flops', label: 'Flip Flops' },
  { value: 'heels', label: 'Heels' },
  { value: 'high-heels', label: 'High Heels' },
  { value: 'stilettos', label: 'Stilettos' },
  { value: 'flats', label: 'Flats' },
  { value: 'sandals', label: 'Sandals' },
  { value: 'boots', label: 'Boots' },

  // Special
  { value: 'pregnant-feet', label: 'Pregnant Feet' },
  { value: 'cosplay-feet', label: 'Cosplay Feet' },
  { value: 'roleplay', label: 'Roleplay' },
  { value: 'foot-worship', label: 'Foot Worship' },
  { value: 'custom-requests', label: 'Custom Requests' }
];

const PAGE_LIMIT = 24;

// Min-rating options → the min_rating query param ('' = omit, contract §4.1)
const MIN_RATING_OPTIONS = [
  { value: '', label: 'Any rating' },
  { value: '3', label: '3+' },
  { value: '4', label: '4+' },
  { value: '4.5', label: '4.5+' },
];

// Content-type options → the repeatable content_type param (contract §4.1).
// Selecting both is OR ("has either"), matching the server.
const CONTENT_TYPE_OPTIONS = [
  { value: 'photo', label: 'Photos', Icon: IconPhoto },
  { value: 'video', label: 'Videos', Icon: IconVideo },
];

// Sort options (contract §4.1) — 'newest' is the server default and is omitted
const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'rating', label: 'Top rated' },
  { value: 'favorites', label: 'Most favorited' },
];

const SellersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(1);

  // Server-side filters (contract §4.1) — like ProductBrowse, the text inputs
  // feed the query directly; every filter change resets to page 1.
  const [searchTerm, setSearchTerm] = useState('');
  const [shoeSize, setShoeSize] = useState('');
  const [country, setCountry] = useState('');
  const [minRating, setMinRating] = useState('');
  const [contentTypes, setContentTypes] = useState([]);
  const [sort, setSort] = useState('newest');
  // Foot-attribute categories, seeded from ?attributes= in the URL. These
  // now drive the server-side `category` filter (§4.1), so they must be
  // declared before the query below reads them.
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const setFilter = (setter) => (value) => {
    setPage(1);
    setter(value);
  };

  const hasActiveFilters =
    !!(searchTerm || shoeSize.trim() || country.trim() || minRating)
    || contentTypes.length > 0
    || selectedAttributes.length > 0
    || sort !== 'newest';

  const handleClearAllFilters = () => {
    setPage(1);
    setSearchTerm('');
    setShoeSize('');
    setCountry('');
    setMinRating('');
    setContentTypes([]);
    setSelectedAttributes([]);
    setSearchParams({});
    setSort('newest');
  };

  const { data, loading, error, refetch } = useApi(
    '/api/v1/sellers',
    {
      page,
      limit: PAGE_LIMIT,
      // Empty filters are omitted from the params (and thus the query key)
      search: searchTerm || undefined,
      shoe_size: shoeSize.trim() || undefined,
      country: country.trim() || undefined,
      min_rating: minRating ? Number(minRating) : undefined,
      // Repeatable params (§4.1): buildQuery appends one entry per item.
      category: selectedAttributes.length ? selectedAttributes : undefined,
      content_type: contentTypes.length ? contentTypes : undefined,
      sort: sort !== 'newest' ? sort : undefined,
    },
    { query: { placeholderData: (prev) => prev } }
  );

  const handleSearch = () => {
    setPage(1);
    refetch();
  };
  const sellers = data?.items ?? [];
  const totalPages = data ? Math.max(1, Math.ceil(data.total / data.limit)) : 1;

  // Parse attributes from URL
  const attributesParam = searchParams.get('attributes');

  useEffect(() => {
    if (attributesParam) {
      const parsed = attributesParam.split(',').filter(Boolean);
      setSelectedAttributes(parsed);
      setShowFilters(true);
    }
  }, [attributesParam]);


  const handleApplyFilters = () => {
    setPage(1);
    if (selectedAttributes.length > 0) {
      setSearchParams({ attributes: selectedAttributes.join(',') });
    } else {
      setSearchParams({});
    }
  };

  const handleClearFilters = () => {
    setPage(1);
    setSelectedAttributes([]);
    setSearchParams({});
  };

  if (loading && sellers.length === 0) {
    return (
      <Container size="lg" py="xl">
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader size="lg" />
        </div>
      </Container>
    );
  }

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <Group justify="space-between" align="center">
          <Title order={1}>Verified Princesses</Title>
          <Button
            variant={showFilters ? "filled" : "light"}
            color="grape"
            leftSection={<IconFilter size="1rem" />}
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? "Hide Filters" : "Show Filters"} {selectedAttributes.length > 0 && `(${selectedAttributes.length})`}
          </Button>
        </Group>

        {/* Search and Filters (contract §4.1, styled like ProductBrowse) */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Stack gap="md">
            <Group align="end" gap="md">
              <TextInput
                label="Search"
                placeholder="Search princesses..."
                leftSection={<IconSearch size="0.9rem" />}
                value={searchTerm}
                onChange={(e) => setFilter(setSearchTerm)(e.currentTarget.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                style={{ flex: 1 }}
              />
              <TextInput
                label="Shoe size"
                placeholder="e.g. 7.5"
                value={shoeSize}
                onChange={(e) => setFilter(setShoeSize)(e.currentTarget.value)}
                style={{ maxWidth: 100 }}
              />
              <TextInput
                label="Country"
                placeholder="Any country"
                value={country}
                onChange={(e) => setFilter(setCountry)(e.currentTarget.value)}
                style={{ minWidth: 140 }}
              />
              <Select
                label="Min rating"
                placeholder="Any rating"
                value={minRating}
                onChange={(value) => setFilter(setMinRating)(value || '')}
                data={MIN_RATING_OPTIONS}
                style={{ minWidth: 120 }}
              />
              <Select
                label="Sort by"
                value={sort}
                onChange={(value) => setFilter(setSort)(value || 'newest')}
                data={SORT_OPTIONS}
                allowDeselect={false}
                style={{ minWidth: 150 }}
              />
              <Button color="grape" onClick={handleSearch} loading={loading}>
                Search
              </Button>
            </Group>

            <Group gap="xs" align="center">
              <Text size="sm" fw={500}>Content</Text>
              <Chip.Group
                multiple
                value={contentTypes}
                onChange={setFilter(setContentTypes)}
              >
                <Group gap="xs">
                  {CONTENT_TYPE_OPTIONS.map(({ value, label, Icon }) => (
                    <Chip key={value} value={value} color="grape">
                      <Group gap={4} align="center" component="span">
                        <Icon size="0.8rem" />
                        {label}
                      </Group>
                    </Chip>
                  ))}
                </Group>
              </Chip.Group>
            </Group>

            {hasActiveFilters && (
              <Button
                variant="subtle"
                color="grape"
                size="xs"
                onClick={handleClearAllFilters}
                style={{ alignSelf: 'flex-start' }}
              >
                Clear filters
              </Button>
            )}
          </Stack>
        </Card>

        {error && (
          <Alert icon={<IconExclamationCircle size="1rem" />} color="red">
            {error.message}
          </Alert>
        )}

        {/* Filter Panel */}
        {showFilters && (
          <Card shadow="md" padding="lg" radius="md" withBorder>
            <Stack gap="md">
              <Group justify="space-between">
                <Text fw={600}>Filter by foot attributes</Text>
                {selectedAttributes.length > 0 && (
                  <Button variant="subtle" size="xs" onClick={handleClearFilters}>
                    Clear All
                  </Button>
                )}
              </Group>

              <Box>
                <Text size="sm" c="dimmed" mb="xs">Selected: {selectedAttributes.join(', ')}</Text>
              </Box>

              <Chip.Group multiple value={selectedAttributes} onChange={setSelectedAttributes}>
                {allAttributes.map((attr) => (
                  <Chip key={attr.value} value={attr.value} color="grape">
                    {attr.label}
                  </Chip>
                ))}
              </Chip.Group>

              <Group justify="right">
                <Button variant="outline" color="grape" onClick={handleClearFilters}>
                  Clear
                </Button>
                <Button color="grape" onClick={handleApplyFilters}>
                  Apply Filters
                </Button>
              </Group>
            </Stack>
          </Card>
        )}

        {selectedAttributes.length > 0 && (
          <Alert color="grape" variant="light">
            <Text>
              {data?.total ?? 0} princess{(data?.total ?? 0) === 1 ? '' : 'es'} match: {selectedAttributes.join(', ')}
            </Text>
          </Alert>
        )}

        {sellers.length === 0 && !loading ? (
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <Text c="dimmed" size="lg">No princesses found</Text>
              <Text c="dimmed" mt="xs">Check back later for new princesses</Text>
            </div>
          </Card>
        ) : (
          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
            {sellers.map((seller) => (
              <SellerCard key={seller.id} seller={seller} />
            ))}
          </SimpleGrid>
        )}

        {totalPages > 1 && (
          <Group justify="center">
            <Pagination value={page} onChange={setPage} total={totalPages} />
          </Group>
        )}
      </Stack>
    </Container>
  );
};

export default SellersPage;
